import { KSYS_GLOBAL_VARIABLES_WINDOW_KEY } from '../constants.js';

import { get } from './get.js';
import { jsonTryParse } from './json.js';

export function getOrchestratedDataset(element: HTMLElement): Record<string, unknown> {
	const response = {};
	if (element) {
		const { dataset = {} } = element;
		for (const [key, rawValue] of Object.entries(dataset)) {
			const tryParseResponse = jsonTryParse(rawValue);
			let value = tryParseResponse.value as any;
			if (typeof value === 'string') {
				const regex = /^\{(global):(.*)\}$/;
				const match = regex.exec(value);
				if (match && match.length > 2) {
					const [, location, path] = match;
					if (location === 'global') {
						if (window[KSYS_GLOBAL_VARIABLES_WINDOW_KEY]) {
							value = get(window[KSYS_GLOBAL_VARIABLES_WINDOW_KEY], path);
						}
					}
				}
			}
			response[key] = value;
		}
	}
	return response;
}
